/** Icone del widget: SVG inline, 20px, tratto 1.75, colore corrente. */

interface Proprieta {
  dimensione?: number;
}

function Svg({ dimensione = 20, children }: Proprieta & { children: React.ReactNode }) {
  return (
    <svg
      width={dimensione}
      height={dimensione}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export const IconaChat = (p: Proprieta) => (
  <Svg {...p}>
    <path d="M21 12a8 8 0 0 1-8 8H7l-4 3V12a8 8 0 0 1 8-8h2a8 8 0 0 1 8 8z" />
    <path d="M9 11h6M9 14h3" />
  </Svg>
);
export const IconaRiduci = (p: Proprieta) => (
  <Svg {...p}>
    <path d="M5 12h14" />
  </Svg>
);
export const IconaEspandi = (p: Proprieta) => (
  <Svg {...p}>
    <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
  </Svg>
);
export const IconaRestringi = (p: Proprieta) => (
  <Svg {...p}>
    <path d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7" />
  </Svg>
);
export const IconaChiudiWidget = (p: Proprieta) => (
  <Svg {...p}>
    <path d="M18 6 6 18M6 6l12 12" />
  </Svg>
);
export const IconaInvia = (p: Proprieta) => (
  <Svg {...p}>
    <path d="M4 12h15M13 6l6 6-6 6" />
  </Svg>
);
export const IconaStop = (p: Proprieta) => (
  <Svg {...p}>
    <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" stroke="none" />
  </Svg>
);
export const IconaRiprova = (p: Proprieta) => (
  <Svg {...p}>
    <path d="M3 12a9 9 0 1 0 3-6.7" />
    <path d="M3 4v5h5" />
  </Svg>
);
export const IconaFreccia = (p: Proprieta) => (
  <Svg {...p}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);
